import { useEffect, useState } from "react";
import DocumentsView from "../DocumentsView";
import { useDispatch } from "react-redux";
import { getData } from "../../../../../../actions/apiCall";

const Reports = ({ candidateId, tabId }) => {
    const [userData, setResData] = useState();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!candidateId || !tabId) return;
        getFormData();
    }, [tabId, candidateId])

    const getFormData = async () => {
        const resData = await dispatch(getData('/form-data-admin/' + candidateId + '/tab/' + tabId));
        if (resData.code == 200) {
            setResData(resData.data);
        }
    }


    return (
        <div>
            <DocumentsView data={userData} onRefresh={() => getFormData()} />
        </div>
    );
}

export default Reports;